var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpcomingFeaturesStars(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.6364 8.72727L21 5.72727L24 4.36364L21 3L19.6364 0L18.2727 3L15.2727 4.36364L18.2727 5.72727L19.6364 8.72727ZM11.4545 9.27273L8.72727 3.27273L6 9.27273L0 12L6 14.7273L8.72727 20.7273L11.4545 14.7273L17.4545 12L11.4545 9.27273ZM19.6364 15.2727L18.2727 18.2727L15.2727 19.6364L18.2727 21L19.6364 24L21 21L24 19.6364L21 18.2727L19.6364 15.2727Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpcomingFeaturesStars);
export default __webpack_public_path__ + "static/media/UpcomingFeaturesStars.18d583f5e320d302467521a2cb71faf6.svg";
export { ForwardRef as ReactComponent };